import { defineComponent as _defineComponent } from 'vue'
import { getDateFormatted, getTimeFormatted12Hours } from '@/services/date'
import { mdiCalendarCheckOutline, mdiClockOutline, mdiLeadPencil } from '@mdi/js'
import { useImage } from '@/shared/composables/image'
import { EventDB } from '@/enitites/event'
import { computed, onMounted, ref } from 'vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useBattle } from '@/enitites/battle'
import CreateEventCancel from './CreateEventCancel.vue'
import CreateEventDelete from './CreateEventDelete.vue'
import { CreateEventFormName } from '../model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventTotal',
  props: {
    isNew: { type: Boolean, default: true },
    eventData: null,
    backStep: { type: Boolean, default: false },
    screen: null
  },
  emits: ["update:screen", "update:backStep", "saveAsDraft", "publishEvent", "updateEvent"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:screen', value: string): void
  (e: 'update:backStep', value: boolean): void
  (e: 'saveAsDraft'): void
  (e: 'publishEvent'): void
  (e: 'updateEvent', value: EventDB): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isNew: boolean, eventData: EventDB, backStep: boolean, screen: CreateEventFormName };

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const { getBattleCategoryName } = useBattle()



const { getImageById } = useImage()


const dateStart = ref(getDateFormatted(props.eventData.dateStart).slice(0, 10) || '')
const dateEnd = ref(getDateFormatted(props.eventData.dateEnd).slice(0, 10) || '')
const timeStart = ref(getTimeFormatted12Hours(props.eventData.dateStart) || '12:00')
const timeEnd = ref(getTimeFormatted12Hours(props.eventData.dateEnd) || '12:00')

const loadingNextBtn = ref(false)
const currentDotNav = ref(6)
const error = ref<null | string>(null)
const isDelete = ref(false)
const isEventHasDates = computed(() => !!props.eventData.dateStart && !!props.eventData.dateEnd)
const isPublished = computed(() => props.eventData.status === 'published')

function handlerClickEdit(step: string) {
  emit('update:backStep', true)
  emit('update:screen', step)
}

function handlerClickNext() {
  error.value = null
  loadingNextBtn.value = true
  if (!isEventHasDates.value) {
    error.value = 'Please select an event date'
    loadingNextBtn.value = false
    return
  }
  emit('publishEvent')
}

function handlerClickBack() {
  emit('update:backStep', false)
  emit('update:screen', 'CreateEventBattles')
}

function handlerClickDelete() {
  isDelete.value = true
}

onMounted(() => {
  emit('update:backStep', false)
})

return { __sfc: true,getBattleCategoryName, emit, getImageById, props, dateStart, dateEnd, timeStart, timeEnd, loadingNextBtn, currentDotNav, error, isDelete, isEventHasDates, isPublished, handlerClickEdit, handlerClickNext, handlerClickBack, handlerClickDelete, mdiCalendarCheckOutline, mdiClockOutline, mdiLeadPencil, store, CreateEventCancel, CreateEventDelete }
}

})